import { service } from '../../../../helpers/http'

export const ActionGetActivityOfferedModalities = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedModality',
        action: 'getActivityOfferedModalities',
        payload: payload
    })

}

export const ActionPostActivityOfferedModality = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedModality',
        action: 'postActivityOfferedModality',
        payload: payload
    })

}

export const ActionPutActivityOfferedModality = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedModality',
        action: 'putActivityOfferedModality',
        payload: payload
    })

}

export const ActionDeleteActivityOfferedModality = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedModality',
        action: 'deleteActivityOfferedModality',
        payload: payload
    })

}
